module.exports = __webpack_public_path__ + "static/media/fig_13d.a20deda6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/fig_13d.jpg
// module id = 638
// module chunks = 0